import { useCallback, useEffect, useState } from 'react';
// Store global muy ligero — sin context provider para simplificar.
const listeners = new Set();
let stack = [];
function emit() {
    for (const l of listeners)
        l([...stack]);
}
export function pushToast(t, autoCloseMs = 6000) {
    const id = (Date.now() + Math.random()).toString(36);
    stack = [...stack, { ...t, id }];
    emit();
    if (autoCloseMs > 0) {
        window.setTimeout(() => dismissToast(id), autoCloseMs);
    }
    return id;
}
export function dismissToast(id) {
    stack = stack.filter((t) => t.id !== id);
    emit();
}
export function useToasts() {
    const [toasts, setToasts] = useState(stack);
    useEffect(() => {
        listeners.add(setToasts);
        return () => { listeners.delete(setToasts); };
    }, []);
    const dismiss = useCallback((id) => dismissToast(id), []);
    return { toasts, dismiss };
}
